import { ViewEntityDialog } from "components/viewDialog/ViewEntityDialog";
import { IViewEntityField } from "components/viewDialog/ViewEntityDialog.types";
import { formatDate } from "utils/generalUtils";
import { IViewCategoryProps } from "./ViewCategory.types";

export const ViewCategory = (props: IViewCategoryProps): JSX.Element => {
  const { category, isOpen, onDismiss } = props;

  const knowledgeComponentsLabel =
    category.tags && category.tags.length > 0
      ? category.tags.map((tag) => tag.name).join(", ")
      : "None";

  const fields: IViewEntityField[] = [
    { label: "Title", value: category.title },
    { label: "Description", value: category.description || "-" },
    { label: "Is Public", value: category.isPublic ? "Yes" : "No" },
    { label: "Knowledge Components", value: knowledgeComponentsLabel },
    { label: "Last Updated", value: formatDate(category.updatedAt) },
  ];

  return (
    <ViewEntityDialog
      isOpen={isOpen}
      onDismiss={onDismiss}
      title="View Category"
      fields={fields}
    />
  );
};
